var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4024 1.24782C11.7328 0.917384 12.2686 0.917394 12.599 1.24784L22.7522 11.4013C23.0826 11.7318 23.0826 12.2675 22.7522 12.5979L12.5991 22.7521C12.2686 23.0826 11.7329 23.0826 11.4024 22.7522C11.072 22.4218 11.0719 21.886 11.4024 21.5556L20.1112 12.8458H1.84615C1.37884 12.8458 1 12.467 1 11.9996C1 11.5323 1.37884 11.1535 1.84615 11.1535H20.1111L11.4024 2.44446C11.0719 2.11402 11.0719 1.57826 11.4024 1.24782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconGo);
export default __webpack_public_path__ + "static/media/button-icon-go.078e3c917165468465563b65ff9b564e.svg";
export { ForwardRef as ReactComponent };